import store from '@/store'
import { http } from '@/plugins/axios'
import { Notify } from 'vant';

// 接口环境
const env = 'development'

// 配置接口环境对应域名 production为线上地址(必须) development为测试地址
const apisURL = {
  production: 'https://api.up-petroleum.com/api/v1/',
  development: 'https://apitest.up-petroleum.com/api/v1/',
}

// 生成接口baseUrl 生产环境强制为production
const baseURL = process.env.NODE_ENV == "production" ? apisURL['production'] : apisURL[env]

/**
 * 获取预约列表
 * @author zZlackZz
 * @returns {Promise<unknown>}
 */
function getSubscribeList() {
  return new Promise((resolve, reject) => {
    http({ method: 'get', url: 'washStation', myBaseUrl: baseURL }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 可洗车加油站详情
 * @param {number} id 洗车站详情
 */
function washStatfo(id) {
  return new Promise((resolve, reject) => {
    if (!id) {
      Notify({ type: 'warning', message: '未知加油站' })
      return
    }

    http({ method: 'get', url: 'washStatfo', data: {id}, myBaseUrl: baseURL }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 预约洗车
 * @param {number} sid 加油站id
 * @param {number} start_time 开始时间
 * @param {number} end_time 结束时间
 */
function appointment({sid, start_time, end_time}) {
  if (!store.state.token) {
    Notify({ type: 'danger', message: '无登录凭证' });
  }
  if (!sid) {
    Notify({ type: 'warning', message: '未知加油站' })
    return
  }
  if (!start_time) {
    Notify({ type: 'warning', message: '未选择时间段' })
    return
  }
  if (!end_time) {
    Notify({ type: 'warning', message: '未选择时间段' })
    return
  }

  return new Promise((resolve, reject) => {
    http({ method: 'post', url: 'appointment', data: {sid, start_time, end_time}, myBaseUrl: baseURL }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取我的订单列表
 * @author zZlackZz
 */
function getMyOrderList() {
  if (!store.state.token) {
    Notify({ type: 'danger', message: '无登录凭证' });
  }
  return new Promise((resolve, reject) => {
    http({ method: 'get', url: 'appoList', myBaseUrl: baseURL }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取预约信息
 * @param id 预约id
 */
function getAppoInfo(id) {
  if (!store.state.token) {
    Notify({ type: 'danger', message: '无登录凭证' });
  }
  if (!id) {
    Notify({ type: 'warning', message: '未知预约订单' })
    return
  }
  return new Promise((resolve, reject) => {
    http({method: 'get', url: 'appoInfo',data:{id}, myBaseUrl: baseURL}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 取消预约
 * @param id 预约id
 */
function callOffAppo(id) {
  if (!store.state.token) {
    Notify({ type: 'danger', message: '无登录凭证' });
  }
  if (!id) {
    Notify({ type: 'warning', message: '未知预约订单' })
    return
  }
  return new Promise((resolve, reject) => {
    http({method: 'post', url: 'cancelAppo',data:{id}, myBaseUrl: baseURL}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 核销洗车
 * @param sid 加油站id
 */
function eliminate(sid) {
  if (!store.state.token) {
    Notify({ type: 'danger', message: '无登录凭证' });
  }
  if (!sid) {
    Notify({ type: 'warning', message: '未知核销对象' })
    return
  }
  return new Promise((resolve, reject) => {
    http({method: 'post', url: 'finishWash',data:{sid}, myBaseUrl: baseURL}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取洗车券
 * @param order_num 订单号
 */
function getCarWashCoupon(order_num) {
  if (!order_num) {
    Notify({ type: 'danger', message: '订单号为空' })
    return
  }
  return new Promise((resolve, reject) => {
    http({method: 'post', url: 'receiveWash',data:{order_num}, myBaseUrl: baseURL}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 获取洗车券列表
 * @param type
 * @param page
 * @param limit
 */
function getWashList(type,page,limit) {
  if (type!==0 && !type) {
    Notify({ type: 'danger', message: '洗车券类型为空' })
    return
  }
  return new Promise((resolve, reject) => {
    http({method: 'get', url: 'washList', data: {type, page, limit}, myBaseUrl: baseURL}).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

export {
  getSubscribeList,
  getMyOrderList,
  washStatfo,
  appointment,
  getAppoInfo,
  callOffAppo,
  eliminate,
  getCarWashCoupon,
  getWashList,
}
